<template>
  <div>
    <div class="col-12 form-group">
      <label for="">آدرس</label>
      <input type="text" class="form-control" v-model="address" disabled>
    </div>
    <div class="row mx-1 my-2">
      <div class="col-6">
        <button class="btn btn-success btn-block" @click="saveAddress">ثبت آدرس و موقعیت</button>
      </div>
      <div class="col-6">
        <button class="btn btn-primary btn-block" @click="saveLocation">ثبت موقعیت</button>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div id="myMap">
        <mapir :apiKey="mapirToken" :center="coordinates">
          <mapMarker
            :coordinates.sync="markerCoordinates"
            color="blue"
            :draggable="true"
            :zoom="15"
          />
          <mapAttributionControl />
          <mapNavigationControl position="top-right" />
          <mapGeolocateControl position="top-right" />
          <mapScaleControl position="top-right" />
        </mapir>
      </div>
      </div>
  </div>
</template>

<script>
import { mapir, mapMarker, mapNavigationControl, mapGeolocateControl, mapScaleControl, mapAttributionControl } from 'mapir-vue'

export default {
  name: 'map',
  components: {
    mapir,
    mapMarker,
    mapNavigationControl,
    mapGeolocateControl,
    mapScaleControl,
    mapAttributionControl
  },
  props: ['project'],
  data () {
    return {
      address: '',
      minZoom: 15,
      Geolocation: true,
      coordinates: [49.688767, 34.086507],
      markerCoordinates: [49.688767, 34.086507],
      mapirToken:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjNlOTljMjMyMTE1M2RiNWNkZDYzYzAzMjMxOTk0M2U0ZmVjNTc4YjMyMmU2MmQ0NDA1MTRkNTg2NzM1MDI5ZTEwMTc3OWI1MWRkNzdkN2U1In0.eyJhdWQiOiI5ODQ4IiwianRpIjoiM2U5OWMyMzIxMTUzZGI1Y2RkNjNjMDMyMzE5OTQzZTRmZWM1NzhiMzIyZTYyZDQ0MDUxNGQ1ODY3MzUwMjllMTAxNzc5YjUxZGQ3N2Q3ZTUiLCJpYXQiOjE1OTMyNjA5MjEsIm5iZiI6MTU5MzI2MDkyMSwiZXhwIjoxNTk1ODUyOTIxLCJzdWIiOiIiLCJzY29wZXMiOlsiYmFzaWMiXX0.sEznd0g7qhvnJR7A38DmYShFj7py9hr26nKEaxiTAaTNIrKEwmuSEbJ4lvJAif_tyLgKzqcGo_EcHeJfQNTPToJGD6DJEt1lC5Xvzs214Mm0tOZs2L9h4DxAfgGMmTIXVEgRF_-7qWymS4XJXJcm_Xi4OuuOA_6NxM_wscmLlPgLMdNnXlxlNsfh0ZyUqoixIwcjyDe9x97If2OphNxAn79T85KiR3TUfCWj0g1D-KGPRhOpG6xnlFO2OeLYlehYcTvOTgpXgSWxe7RU_aVb0UeC9MTEv81DG-LETZoRuI0wHELwJiyMg4JW7Pvy5x6j8yvVVFTrxR_BV0Or3dpIfg' // your access token. Needed if you using Mapbox maps
    }
  },
  beforeMount () {
    this.address = this.project.address
    if (this.project.longitude) {
      this.markerCoordinates = [this.project.longitude, this.project.latitude]
    }
  },
  watch: {
    markerCoordinates: function (val) {
      const that = this
      fetch('https://map.ir/reverse?lat=' + val[1] + '&lon=' + val[0] + '&x-api-key=' + this.mapirToken)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
          that.address = data.address
        })
    }
  },
  created () {
    this.map = null
  },
  methods: {
    onMapLoaded (event) {
      this.map = event.map
      this.$store.map = event.map
    },
    saveAddress () {
      this.$send.submit('post', 'api/project/map/' + this.$route.params.id, { address: this.address, location: this.markerCoordinates })
        .then(response => {
          this.$parent.getProject()
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'آدرس و موقعیت پروژه موفقیت ویرایش شد!',
            'success', {
              button: 'باشه'
            })
        })
    },
    saveLocation () {
      this.$send.submit('post', 'api/project/map/' + this.$route.params.id, { location: this.markerCoordinates })
        .then(response => {
          this.$parent.getProject()
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'موقعیت پروژه موفقیت ویرایش شد!',
            'success', {
              button: 'باشه'
            })
        })
    }
  }
}
</script>

<style>
#myMap {
  width: 80vw;
  height: 60vh;
}
</style>
